import React from "react";
import ReactPaginate from "react-paginate";
import { NextIcon, PrevIcon } from "./ProjectIcons";
import { MoonLoader } from "react-spinners";

type PaginationProps = {
  handlePageClick: (selectedItem: { selected: number }) => void;
  pageCount: number;
  recordStart: number;
  recordEnd: number;
  totalCount: number;
  loading: boolean;
  pageSize: number;
  selectPage: boolean;
  searchQuery: { pageNumber: number };
};

const Pagination: React.FC<PaginationProps> = ({
  handlePageClick,
  pageCount,
  recordStart,
  recordEnd,
  totalCount,
  loading,
  pageSize,
  selectPage,
  searchQuery,
}) => (
  <div
    className={
      !selectPage
        ? "fixed bottom-0 left-0 right-0 flex justify-center w-full bg-grayScale-600"
        : "flex justify-center w-full"
    }
  >
    {totalCount > 0 &&
      (loading ? (
        <div className="flex justify-center items-center">
          <span className="w-full text-grayScale-400 py-2 md:ml-6">
            <MoonLoader color="#9EB45B" />
          </span>
        </div>
      ) : (
        <span className="w-full hidden sm:flex text-grayScale-400 py-2 md:ml-6">
          Showing {recordStart} to {recordEnd} of {totalCount}
        </span>
      ))}
    <ReactPaginate
      previousLabel={totalCount > pageSize ? <PrevIcon /> : null}
      nextLabel={totalCount > pageSize ? <NextIcon /> : null}
      breakLabel=". . ."
      pageCount={pageCount}
      marginPagesDisplayed={1}
      pageRangeDisplayed={1}
      onPageChange={(selectedItem) => handlePageClick(selectedItem)} // Fix here
      containerClassName="pagination flex flex-row text-grayScale-400 justify-end my-0 pt-2 pb-1 mr-8 w-full"
      pageClassName="mx-4"
      activeClassName="active border border-slate-200 px-2 text-grayScale-400 rounded-full"
      forcePage={searchQuery.pageNumber - 1}
    />
  </div>
);

export default Pagination;
